import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { User_Authentication } from '../../../../user_authentication/User_Authentication';
import { get_astro_reviews } from '../../../../api/astrologer/Astrologer';
import Astrologer_after_Login_Header from '../astrologer_after_login_header/Astrologer_after_Login_Header';
import Astrologer_Footer from '../astrologer_footer/Astrologer_Footer';
import Loader from '../../../../loader/Loader';
import { IMG_BASE_URL } from '../../../../config/Config';

const Astrologer_All_Reviews_List = () => {
    const [isLoading, setIsLoading] = useState(false)
    const [get_astrologer_reviews_list, set_Astrologer_reviews_list] = useState([]);

    const [currentPage, setCurrentPage] = useState(1);
    const productsPerPage = 9;

    // Calculate total pages safely
    const totalPages = Math.ceil(get_astrologer_reviews_list?.length / productsPerPage) || 1;

    // Calculate the products to display on the current page
    const startIndex = (currentPage - 1) * productsPerPage;

    const currentProduct = [...(get_astrologer_reviews_list || [])]?.sort((a, b) => new Date(b.created_at) - new Date(a.created_at)).slice(startIndex, startIndex + productsPerPage) || [];

    // Pagination controls
    const getPaginationItems = () => {
        const items = [];
        if (totalPages <= 5) {
            for (let i = 1; i <= totalPages; i++) {
                items.push(i);
            }
        } else {
            if (currentPage <= 3) {
                items.push(1, 2, 3, 4, '...', totalPages);
            } else if (currentPage >= totalPages - 2) {
                items.push(1, '...', totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
            } else {
                items.push(1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages);
            }
        }
        return items;
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleNext = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePrev = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const formatDateTime = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleString('en-US', {
            year: 'numeric',
            month: 'short', // "Jan"
            day: '2-digit', // "24"
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: true // Convert to 12-hour format (AM/PM)
        });
    };


    const handle_get_astrologer_reviews = async () => {
        try {
            setIsLoading(true);
            const token = User_Authentication();
            if (!token) {
                setIsLoading(false);
                toast("Token not found");
                throw new Error("User token not found");
            }
            const response = await get_astro_reviews({ Authorization: `Bearer ${token}` });
            if (response?.data?.status == "200") {
                set_Astrologer_reviews_list(response?.data?.data?.pooja_reviews);
            } else if (response?.data?.status == "400") {
                toast.error(response?.response?.data?.message)
            }
        } catch (error) {
            console.error("API Error:", error.response?.data || error.message);
        } finally {
            setIsLoading(false); // Stop loading after request
        }
    };

    // Call function inside useEffect
    useEffect(() => {
        handle_get_astrologer_reviews();
    }, []);

    // Function for date formatter
    const formatDate = (isoDate) => {
        const date = new Date(isoDate);
        const day = date.getDate().toString().padStart(2, '0');
        const month = date.toLocaleString('en-US', { month: 'short' });
        const year = date.getFullYear();
        const time = date.toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
        });

        return `${day} ${month}, ${year} AT ${time}`;
    };

    return (
        <>
            {/*  */}
            <Astrologer_after_Login_Header />
            {
                isLoading ? <Loader /> :
                    <section className="gi-product-tab gi-products py-[30px] pb-[60px] max-[767px]:py-[30px] wow fadeInUp"
                        data-wow-duration="2s">
                        <div
                            className="flex flex-wrap justify-between items-center mx-auto min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px] pb-5">
                            <div className="gi-tab-title w-full inline-flex justify-between px-[12px] max-[991px]:flex-col items-center">
                                <div className="gi-main-title">
                                    <div className="section-title mb-[20px] pb-[20px] flex ">
                                        <div className="section-detail">
                                            <h2 className="gi-title mb-[0] text-[25px] max-[991px]:text-[24px] max-[767px]:text-[22px] max-[575px]:text-[20px] font-semibold text-[#4b5966] relative inline p-[0]  leading-[1] font-Poppins tracking-[0.01rem]">
                                                My Reviews</h2>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="w-full mb-[-24px]">
                                <div
                                    className="custome_jewellery ">
                                    {currentProduct?.length > 0 ?
                                        (
                                            currentProduct.map((review_result) => (
                                                <div
                                                    className="gi-t-review-item p-5 border-b-[1px] border-solid border-[#eee]">
                                                    <div className="gi-t-review-content">
                                                        <div className="gi-t-review-top flex items-center mb-[10px]">
                                                            <div className="gi-t-review-avtars basis-[70px] grow-[0] shrink-[0] mr-[10px]">
                                                                <img src={`${IMG_BASE_URL}${review_result?.users?.
                                                                    profile_image
                                                                    }`} alt="user"
                                                                    className="max-w-full rounded-full w-16 h-16" />
                                                            </div>
                                                            <div className="w-full">
                                                                <h4
                                                                    className="gi-t-review-name font-medium text-[18px] m-[0] leading-[1.5] block text-[#000]">
                                                                    {review_result?.users?.name
                                                                    }</h4>
                                                                <div className="flex justify-between items-center">
                                                                    <div className="gi-t-review-rating mt-2">
                                                                        {[...Array(5)].map((_, i) => (
                                                                            <i
                                                                                key={i}
                                                                                className={`gicon gi-star inline-block float-left text-[14px] mr-[3px] ${i < review_result.rating ? 'text-[#f27d0c]' : 'text-[#ccc]'
                                                                                    }`}
                                                                            ></i>
                                                                        ))}



                                                                    </div>
                                                                    <div className="text-sm text-gray-500">{formatDate(review_result?.created_at)}</div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                        <div className="gi-t-review-bottom">

                                                            <p className="w-full text-[14px] text-[#777] font-normal line-clamp-5 mt-3">
                                                                {review_result?.review}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                        )
                                        : (
                                            <p class="text-gray-500 text-center">No reviews yet.</p>
                                        )
                                    }
                                </div>
                            </div>
                            {/* <!-- Pagination Start --> */}
                            <div className="mt-5 w-full px-4 gi-pro-pagination pt-[15px] pb-[15px] flex justify-between items-center  max-[575px]:flex-col">
                                <span className="text-[14px] text-[#777] max-[575px]:mb-[10px]">Showing {startIndex + 1}-{Math.min(startIndex + productsPerPage, get_astrologer_reviews_list?.length)} of {get_astrologer_reviews_list?.length} reviews</span>
                                <ul className="gi-pro-pagination-inner flex gap-1">
                                    {currentPage > 1 && (
                                        <li>
                                            <button
                                                onClick={handlePrev}
                                                className="next w-auto text-[#fff] bg-[#5caf90] bg-red-500 text-[14px] px-2 rounded"
                                            >
                                                Prev
                                            </button>
                                        </li>
                                    )}
                                    {getPaginationItems().map((page, index) => {
                                        if (page === '...') {
                                            return (
                                                <li key={`ellipsis-${index}`} className="inline-block float-left">
                                                    <span className="transition-all duration-[0.3s] ease-in-out text-[#777] text-[14px]">
                                                        ...
                                                    </span>
                                                </li>
                                            );
                                        }
                                        return (
                                            <li key={page} className="inline-block float-left">
                                                <button
                                                    onClick={() => handlePageChange(page)}
                                                    className={`transition-all duration-[0.3s] ease-in-out font-light 
                                                        text-[#777] bg-[#eee] px-2
                                                        text-[14px] rounded
                                                        ${currentPage === page ? 'active bg-red-500 text-white' : 'bg-gray-300 text-black'}`}
                                                >
                                                    {page}
                                                </button>
                                            </li>
                                        );
                                    })}
                                    {currentPage < totalPages && (
                                        <li>
                                            <button
                                                onClick={handleNext}
                                                className="next w-auto text-[#fff] px-2 bg-[#5caf90] text-[14px] rounded"
                                            >
                                                Next
                                            </button>
                                        </li>
                                    )}
                                </ul>

                            </div>
                        </div>
                    </section>

            }
            {/*  */}
            <Astrologer_Footer />
        </>
    )
}

export default Astrologer_All_Reviews_List